import type { LoaderFunction, LoaderFunctionArgs } from 'react-router-dom';
import { apiListGetUserByToken } from "../../components/ui_components/ApiList";
import { redirect } from "react-router-dom";

async function checkIsFounder(): Promise<boolean> {
    try {
        const user = await apiListGetUserByToken();

        if (!user || !user.username) {
            return false;
        }

        return !!user.is_founder;
    } catch (error) {
        console.error('Errore durante il controllo founder:', error);
        return false;
    }
}

export const FounderRouteProtection: LoaderFunction = async () => {
    const isFounder = await checkIsFounder();

    if (!isFounder) {
        return redirect('/');
    }

    return null;
};

export function combineFounderLoader(loaderFunction?: LoaderFunction): LoaderFunction {
    return async (args: LoaderFunctionArgs) => {
        const isFounder = await checkIsFounder();

        if (!isFounder) {
            return redirect('/');
        }

        if (loaderFunction) {
            return await loaderFunction(args);
        }

        return null;
    };
}
